import { z } from 'zod';

export enum PageUrlKey {
  DEFAULT_LANDING_PAGE = 'default-landing-page',
  PROJECTS = 'projects',
  PROJECT = 'project',
  ALERTS = 'alerts',
  ALERTS_EXPORT = 'alerts/export',
  BENCHMARK = 'benchmark',
  CAPACITY_TEST = 'capacity-test',
  CHANGELOG = 'changelog',
  DATA_COMPATIBILITY = 'data-compatibility',
  DATA_EXPLORER = 'data-explorer',
  DOCUMENTS = 'documents',
  OVERVIEW = 'overview',
  PCS = 'pcs',
  DETAILS = 'details',
  SITE_MAP = 'site-map',
  TASKS = 'tasks',
  WARRANTY = 'warranty',
  ALERT_NOTIFICATIONS = 'alert-notifications',
  CONTRACTS = 'subscriptions',
  PLATFORM_STATUS = 'availability',
  COMMUNICATION = 'communication',
  SITEVIEW = 'siteview',
  TRUST_CENTER = 'trust-center',
  USER_MANAGEMENT = 'user-management',
  USER_PREFERENCES = 'user-preferences',
  SITEVIEW_CONFIGURATOR = 'siteview-configurator',
  SYSTEM_LOGS = 'system-logs',
}

export const PageUrlKeySchema = z.nativeEnum(PageUrlKey);
export type PageUrlKeyType = z.infer<typeof PageUrlKeySchema>;
